import { buildAbsoluteProductUrl } from '@/lib/urls';
import type { CategoryInitialResultObject } from '@/types/generated';

const TOP_ITEMS_COUNT = 3;

type ItemListElement = {
    '@type': 'ListItem';
    position: number;
    name: string;
    url: string;
};

export function buildCategoryItemListJsonLd(
    name: string,
    items: CategoryInitialResultObject[],
    storeCode: string | null | undefined,
    origin: string | null | undefined,
): Record<string, unknown> | null {
    const topItems = items.slice(0, TOP_ITEMS_COUNT);

    if (topItems.length === 0) {
        return null;
    }

    const itemListElement: ItemListElement[] = topItems.map((item: CategoryInitialResultObject, index: number): ItemListElement => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        url: buildAbsoluteProductUrl(item.url, storeCode, origin) ?? item.url,
    }));

    return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name,
        itemListElement,
    };
}
